import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=5bb499ad&scoped=true&"
import script from "./reporting.vue?vue&type=script&lang=js&"
export * from "./reporting.vue?vue&type=script&lang=js&"
import style0 from "./reporting.vue?vue&type=style&index=0&id=5bb499ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb499ad",
  null
  
)

export default component.exports